// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1IoqJ","box":"WorkspacesBox_box__2myZB","node":"WorkspacesBox_node__13aWb"};